// src/pages/AdminDatosMaestrosListaPage.js
import React, { useEffect } from 'react';
import { Link, Navigate, useParams } from 'react-router-dom';
import { useAuth } from '../auth/AuthContext';
import { buscarLista, listaVisible, RUTA_DATOS_MAESTROS } from '../components/admin/datosMaestrosListas';
import '../style/pages/HomePage.css';
import '../style/pages/AdminDatosMaestrosPage.css';

/**
 * Página de gestión de UNA lista de Datos Maestros (/admin/datos-maestros/<clave>): el mismo
 * componente Gestion* de siempre, a ancho completo, con un encabezado que dice qué lista es y
 * un enlace para volver al panel de tarjetas.
 *
 * Una clave inexistente, o una lista que el usuario no puede ver (quien tiene solo
 * 'datosMaestros.carpetas.ver' entra únicamente a Carpetas), vuelve al panel.
 */
const AdminDatosMaestrosListaPage = () => {
    const { clave } = useParams();
    const { puede } = useAuth();
    const lista = buscarLista(clave);
    const permitida = Boolean(lista) && listaVisible(lista, puede('datosMaestros.ver'));

    // Se llega desde el panel, que puede estar scrolleado hasta las últimas secciones. Salto
    // inmediato: el html de la app tiene `scroll-behavior: smooth` y se veía la página subir.
    useEffect(() => {
        window.scrollTo({ top: 0, left: 0, behavior: 'instant' });
    }, [clave]);

    if (!permitida) {
        return <Navigate to={RUTA_DATOS_MAESTROS} replace />;
    }

    const { Componente } = lista;

    return (
        <div className="homepage-container datos-maestros-page area-admin">
            <header className={`dm-lista-header dm-tono-${lista.tono}`}>
                <span className="dm-tarjeta-icono">
                    <i className={`bi ${lista.icono}`} aria-hidden="true"></i>
                </span>
                <div>
                    <span className="dm-lista-seccion">{lista.seccion}</span>
                    <h1 className="dm-lista-titulo">{lista.titulo}</h1>
                    <p className="dm-lista-descripcion">{lista.descripcion}</p>
                </div>
                <Link to={RUTA_DATOS_MAESTROS} className="dm-volver">
                    <i className="bi bi-arrow-left" aria-hidden="true"></i>
                    Datos Maestros
                </Link>
            </header>

            <div className="dm-lista-panel rounded-4 shadow-sm">
                {/* `key`: al pasar de una lista a otra se remonta y recarga sus datos */}
                <Componente key={lista.clave} />
            </div>
        </div>
    );
};

export default AdminDatosMaestrosListaPage;
